import _TextField from "@material-ui/core/esm/TextField";
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import { emailBlockDispatcher } from '../../../../../redux/share-design/share-design.dispatchers';
import { emailBlockSelector } from '../../../../../redux/share-design/share-design.selectors';
import classes from './email-block.scss';
const EmailBlock = ({
  editEmail,
  sendMockup,
  email,
  error,
  isLimitedEdition
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.emailBlockContainer
}, /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.emailInputBlock, {
    [classes.orangeBorder]: isLimitedEdition
  })
}, /*#__PURE__*/React.createElement(_TextField, {
  "data-input": "Email",
  placeholder: "Your Email: ",
  fullWidth: true,
  value: email,
  name: "email",
  type: "email",
  onChange: event => editEmail(event.target.value),
  className: classnames(classes.input, {
    [classes.orangeBorder]: isLimitedEdition
  })
}), error && /*#__PURE__*/React.createElement("div", {
  className: classes.error
}, error)), /*#__PURE__*/React.createElement(Button, {
  dataButton: "Send",
  type: "primary",
  size: "small",
  onClick: sendMockup,
  className: classnames(classes.emailSendButton, {
    [classes.orangeBackground]: isLimitedEdition
  })
}, "Send"));
export default connect(emailBlockSelector, emailBlockDispatcher)(EmailBlock);